export const CHECKBOX_COLUMN = "checkboxColumn";

// Hard limit on the number of rows that can be displayed by ag-grid in modern browsers
// for explanation and solution (threshold to be removed) see https://ag-grid.com/javascript-data-grid/massive-row-count/
export const MAX_ROW_COUNT = 400000;

export const COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID = "column-selection-button-placeholder";
export const COLUMN_SELECTION_GUIDANCE_TIMER = 5000;
